import { create } from 'zustand';

import { IIndividualCustomer } from '@/models/profiles';

interface ICustomerInfoStore {
  customerInfo: IIndividualCustomer | undefined;
  isError: boolean;
  isFetching: boolean;
  setCustomerInfo: (data: IIndividualCustomer | undefined, isError: boolean) => void;
  setIsFetching: (fetching: boolean) => void;
}

export const useCustomerInfoStore = create<ICustomerInfoStore>((set) => ({
  customerInfo: undefined,
  isError: false,
  isFetching: false,
  setCustomerInfo: (data, isError) => {
    set({ customerInfo: data, isError });
  },
  setIsFetching: (fetching) => set({ isFetching: fetching }),
}));
